<template>
  <span class="ffs-badge" :title="$t('patient.ffsPatient')" data-test="badgePatientFfs">FFS</span>
</template>

<style lang="scss" scoped>
.ffs-badge {
  display:                        inline-block;
  color:                          #FFF;
  font-size:                      var(--font-size-10);
  font-weight:                    700;
  line-height:                    1;
  letter-spacing:                 0.5px;
  vertical-align:                 middle;
  white-space:                    nowrap;
  flex-shrink:                    0;
  margin-left:                    6px;
  padding:                        3px 6px;
  background:                     var(--Brand-Primary-BG);
  border-radius:                  4px;
}
</style>

<script>
export default {
  name: 'BaseFfsBadge'
}
</script>
